import React from 'react';
import { useField } from 'formik';

import {
  Select,
  InputLabel,
  FormHelperText,
  FormControl,
  makeStyles,
} from '@material-ui/core';

// todo move this to own select component
const useStyles = makeStyles(() => ({
  formControl: {
    display: 'flex'
  }
}));

const FormikSelect = ({
  id,
  afterChange,
  options,
  label: selectLabel,
  multiple,
  helperText,
  isRequired,
  ...props
}: any) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const classes = useStyles();
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  return (
    <FormControl required={isRequired} variant="outlined" className={classes.formControl} {...props}>
      <InputLabel id={`${id}-input-label`} shrink>{selectLabel}</InputLabel>
      <Select
        id={props.name}
        label={selectLabel}
        inputProps={{
          name: props.name,
          id,
        }}
        native={Boolean(!multiple)}
        error={Boolean(error)}
        {...props}
        {...field}
        value={field.value || ''}
        onChange={(e) => {
          field.onChange(e);
          if (afterChange) afterChange(e.target.value);
        }}
      >
        <option>&nbsp;</option>
        {options.map(({
          label,
          value
        }: any) => <option key={value} value={value}>{label}</option>)}
      </Select>
      {
        helperText && (
          <FormHelperText>
            {helperText}
          </FormHelperText>
        )
      }
      {
        error && (
          <FormHelperText error>
            {error}
          </FormHelperText>
        )
      }
    </FormControl>
  );
};

export default FormikSelect;
